/**
 * Helpers for coercing legacy ERP / Firebird rows into domain scalars.
 * Keys may arrive lowercased; pick() tries both casings.
 */
export function pick(row, ...keys) {
    for (const key of keys) {
        if (row[key] !== undefined && row[key] !== null)
            return row[key];
        const lower = key.toLowerCase();
        if (row[lower] !== undefined && row[lower] !== null)
            return row[lower];
    }
    return undefined;
}
export function optionalString(value) {
    if (value === undefined)
        return undefined;
    if (value === null || value === '')
        return null;
    return String(value);
}
export function optionalNumber(value) {
    if (value === undefined)
        return undefined;
    if (value === null || value === '')
        return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}
export function optionalBoolean(value) {
    if (value === undefined || value === null || value === '')
        return undefined;
    if (typeof value === 'boolean')
        return value;
    if (typeof value === 'number')
        return value !== 0;
    const s = String(value).trim().toLowerCase();
    if (s === 'true' || s === '1' || s === 'yes' || s === 's' || s === 'sim')
        return true;
    if (s === 'false' || s === '0' || s === 'no' || s === 'n' || s === 'nao' || s === 'não') {
        return false;
    }
    return !!value;
}
export function optionalDate(value) {
    if (value === undefined)
        return undefined;
    if (value === null || value === '')
        return null;
    if (value instanceof Date)
        return Number.isNaN(value.getTime()) ? null : value;
    const d = new Date(String(value));
    return Number.isNaN(d.getTime()) ? null : d;
}
/** Digits-only scalar (CPF/CNPJ/NCM). Empty after strip → null; omitted → undefined. */
export function optionalDigits(value) {
    const s = optionalString(value);
    if (s === undefined)
        return undefined;
    if (s === null)
        return null;
    const digits = s.replace(/\D/g, '');
    return digits === '' ? null : digits;
}
export function requireNumber(value, field) {
    const n = optionalNumber(value);
    if (n == null || !Number.isFinite(n)) {
        throw new Error(`[legacyRowMappers] Row is missing required numeric field "${field}".`);
    }
    return n;
}
//# sourceMappingURL=legacyRow.js.map